'use client';

import { useParams } from 'next/navigation';
import classes from './VerticalCardList.module.scss';
import { Container, Grid } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { Article, Product } from '@/src/types/Header';
import { Title } from '../../Title/Title';
import { VerticalCard } from './VerticalCard/VerticalCard';

export default function VerticalCardList({
  articles,
  products,
  data,
  showTitle = true,
}: {
  articles?: Article[];
  products?: Product[];
  data: any;
  showTitle?: boolean;
}) {
  const { lang } = useParams();
  useAOS();

  const hasArticles = Array.isArray(articles) && articles.length > 0;
  const hasProducts = Array.isArray(products) && products.length > 0;

  return (
    <section className={classes.section}>
      <Container>
        {showTitle && <Title title={data.title} />}

        <Grid align="stretch" gutter="xl">
          {hasArticles
            ? articles!.map((article: any) => (
              <Grid.Col span={{ base: 12, sm: 6, md: 4 }} key={article.title}>
                <VerticalCard article={article} />
              </Grid.Col>
            ))
            : hasProducts
              ? products!.map((product: any) => (
                <Grid.Col
                  span={{ base: 12, sm: 6, md: 4 }}
                  // @ts-ignore
                  key={product.title?.[lang] ? product.title[lang] : product.title}
                >
                  <VerticalCard product={product} />
                </Grid.Col>
              ))
              : null}
        </Grid>
      </Container>
    </section>
  );
}
